<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";

import {
    GetDataMethods,
    PostDataMethods
} from "@/state/helpers";

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader
    },
    data() {
        return {
            countPage: 1,
            title: "Users",
            items: [
                {
                    text: "Wesal"
                },
                {
                    text: "Deposit",
                }
            ],
            i: 20,
            totalRows: 1,
            topUpData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            fields: [
                { key: "id", sortable: false, label: "ID" },
                { key: "user_id", sortable: false, label: "User ID" },
                { key: "name", sortable: false, label: "Name" },
                { key: "number", sortable: false, label: "Number" },
                { key: "amount", sortable: false, label: "Amount" },
                { key: "note", sortable: false, label: "Note" },
                { key: "bank_id", sortable: false, label: "Bank Id" },
                { key: "confirmed", sortable: false, label: "Confimed" },
                { key: "status", sortable: false, label: "Status" },
                { key: "img", sortable: false, label: "Image" },
                { key: "created_at", sortable: false, label: "Created At" },
                { key: "updated_at", sortable: false, label: "Updated At" },
                //{ key: "id", sortable: false, label: "Action" }
            ]
        }
    },
    computed: {

        rows() {
            return this.countPage;
        },

    },
    mounted() {
        // Set the initial number of items
        this.GetOrderData()

    },
    watch: {
        currentPage: function () {
            this.GetOrderData()
        }
    },
    methods: {
        ...GetDataMethods,
        ...PostDataMethods,

        async GetOrderData() {
            this.getData("get_topUps?page=" + this.currentPage).then((res) => {
                console.log(res)
                this.topUpData = res.data.data
                this.countPage = res.data.total

            })
        },

        async acceptItem($val) {
            this.postData({ key: "accept_topUp/" + $val }).then(response => {
                if (response.status == 404)
                    this.makeToast("danger ", "Fial", response.data.message);
                else if (response.status == 500)
                    this.makeToast("danger ", "Fial", response.data.message);
                else {
                    this.makeToast("success ", "Success", response.data.message);
                    window.location.reload();
                }

            })
        },
        async refuseItem($val) {
            this.postData({ key: "refuse_topUp/" + $val }).then(response => {
                if (response.status == 404)
                    this.makeToast("danger ", "Fial", response.data.message);
                else if (response.status == 500)
                    this.makeToast("danger ", "Fial", response.data.message);
                else {
                    this.makeToast("success ", "Success", response.data.message);
                    window.location.reload();
                }

            })
        },


        makeToast(variant = null, body = null, title = null) {
            this.$bvToast.toast(title, {
                title: `${body}`,
                variant: variant,
                solid: true,
            });
        },

    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <b-tabs nav-class="nav-tabs-custom">
                            <b-tab title-link-class="p-3">
                                <template v-slot:title>
                                    <a class="font-weight-bold active">All Deposit</a>
                                </template>
                                <div class="row mt-4">
                                    <div class="col-sm-12 col-md-6">

                                    </div>
                                    <!-- Search -->
                                    <!-- <div class="col-sm-12 col-md-6">
                                        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                            <label class="d-inline-flex align-items-center">
                                                Search:
                                                <b-form-input v-model="filter" type="search"
                                                    class="form-control form-control-sm ml-2"></b-form-input>
                                            </label>
                                        </div>
                                    </div> -->
                                    <!-- End search -->
                                </div>
                                <div class="table-responsive">
                                    <b-table class="table-centered" :items="topUpData" :fields="fields" responsive="sm"
                                        :per-page="perPage">

                                        <template v-slot:cell(img)="data">
                                            <img :src="data.value" alt="Image" width="100%">
                                        </template>

                                        <template v-slot:cell(user_.id)="data">
                                            <router-link :to="{ name: 'user', params: { id: data.value } }">{{
                                                data.value }}</router-link>
                                        </template>

                                        <template v-slot:cell(created_at)="data">
                                            <div>{{ data.value | formatDate }}</div>
                                        </template>

                                        <template v-slot:cell(updated_at)="data">
                                            <div>{{ data.value | formatDate }}</div>
                                        </template>

                                        <!-- <template v-slot:cell(id)="data">
                                            <b-button variant="success" size="sm" class="mr-2" title="Accept"
                                                @click="acceptItem(data.value)">
                                                <i class="mdi mdi-check font-size-16"></i> Accept
                                            </b-button>
                                            <b-button variant="danger" size="sm" title="Refuse"
                                                @click="refuseItem(data.value)">
                                                <i class="mdi mdi-close font-size-16"></i> Refuse
                                            </b-button>
                                        </template> -->

                                    </b-table>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="dataTables_paginate paging_simple_numbers float-right">
                                            <ul class="pagination pagination-rounded mb-0">
                                                <!-- pagination -->
                                                <b-pagination v-model="currentPage" :total-rows="rows"
                                                    :per-page="perPage"></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>